var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AmChartsBase_keyLicense;
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5locales_es_ES from '@amcharts/amcharts5/locales/es_ES';
import am5locales_ca_ES from '@amcharts/amcharts5/locales/ca_ES';
import am5locales_en from '@amcharts/amcharts5/locales/en_US';
import am5themesAnimated from '@amcharts/amcharts5/themes/Animated';
import { getLocale } from '../../../i18n/localize';
import { ChartRange } from './chartRange';
export class AmChartsBase {
    /**
     * If the root element is not set, then set the xAxisType,
     * set the license key, create the root element, and create the chart by type.
     * @param {string | HTMLElement} rootElement - string | HTMLElement,
     * @param {string | HTMLElement} rootLegendElement - string | HTMLElement,
     * @param {TypeCharts} typeChart - TypeCharts
     * @param {string | Number | Date} typeCategory - string | Number | Date
     */
    constructor(rootElement, typeChart, typeCategory, model, rootLegendElement, chartOptions) {
        /**
         * Define the License Key AmCharts5
         */
        _AmChartsBase_keyLicense.set(this, 'AM5C342714516');
        /**
         * Define yAxis units of chart
         */
        this.yAxisUnits = {};
        this.enableSerieAnimation = false;
        /**
         * Define all xAxis of chart
         */
        this.xAxisAll = [];
        /**
         * Define all yAxis of chart
         */
        this.yAxisAll = [];
        this.seriesModel = [];
        // Setting the xAxisType to the type of the typeCategory.
        this.xAxisType = this.checkXAxisType(typeCategory);
        this.typeChart = typeChart;
        if (chartOptions) {
            this.chartOptions = chartOptions;
        }
        // Setting the license key for the AmCharts5 library.
        this.setLicenseKey();
        // Creating the root element of the chart.
        const root = this.createRootElement(rootElement);
        this.root = root;
        // Set autoResize option
        if ((chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.autoResize) !== null && (chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.autoResize) !== undefined) {
            this.root.autoResize = chartOptions.autoResize;
        }
        const legendRoot = this.createLegendRootElement(rootLegendElement);
        this.rootLegend = legendRoot;
        // Creating the chart by type.
        const chart = this.createChartByType(typeChart);
        this.chart = chart;
        if (this.root) {
            this.formatLocale();
        }
        if (model) {
            this.enableSerieAnimation = true;
            this.setAxisFromModel(model);
        }
        else {
            const { xAxis, yAxis } = this.createAxis();
            this.xAxis = xAxis;
            this.yAxis = yAxis;
        }
        if (!this.xAxis)
            return;
        this.createAxisRanges(model);
    }
    createAxisRanges(model) {
        // If not exist model not continue
        if (!model)
            return;
        const { models } = model;
        models.forEach((modelItem) => {
            // xAxisRange
            const { xAxisRange } = modelItem;
            xAxisRange === null || xAxisRange === void 0 ? void 0 : xAxisRange.forEach((i) => {
                var _a, _b;
                const xAxis = this.xAxisAll.find((y) => y.name === i.id);
                const rangeDataItem = xAxis.makeDataItem({
                    value: (_a = i.startDate) === null || _a === void 0 ? void 0 : _a.getTime(),
                    endValue: (_b = i.endDate) === null || _b === void 0 ? void 0 : _b.getTime(),
                    above: false,
                });
                // Create the Axis Range
                xAxis.createAxisRange(rangeDataItem);
                let { centerX, centerY } = i.labelProperties;
                let { fill } = i.fillProperties;
                let { stroke } = i.strokeProperties;
                // If a number arrives we convert it to a percentage
                if (typeof centerX === 'number')
                    centerX = am5.percent(centerX);
                if (typeof centerY === 'number')
                    centerY = am5.percent(centerY);
                if (typeof fill === 'string')
                    fill = am5.color(fill);
                if (typeof stroke === 'string')
                    stroke = am5.color(stroke);
                rangeDataItem.get('grid').setAll({ ...i.strokeProperties, stroke });
                rangeDataItem.get('axisFill').setAll({ ...i.fillProperties, fill });
                rangeDataItem.get('label').setAll({ ...i.labelProperties, centerX, centerY });
            });
            // yAxisRange
            const { yAxisRange } = modelItem;
            yAxisRange === null || yAxisRange === void 0 ? void 0 : yAxisRange.forEach((i) => {
                const yAxis = this.yAxisAll.find((y) => y.name === i.id);
                const rangeDataItem = yAxis.makeDataItem({
                    value: i.value,
                    endValue: i.endValue,
                    above: false,
                });
                // Create the Axis Range
                yAxis.createAxisRange(rangeDataItem);
                let { centerX, centerY } = i.labelProperties;
                let { fill } = i.fillProperties;
                let { stroke } = i.strokeProperties;
                // If a number arrives we convert it to a percentage
                if (typeof centerX === 'number')
                    centerX = am5.percent(centerX);
                if (typeof centerY === 'number')
                    centerY = am5.percent(centerY);
                if (typeof fill === 'string')
                    fill = am5.color(fill);
                if (typeof stroke === 'string')
                    stroke = am5.color(stroke);
                rangeDataItem.get('axisFill').setAll({
                    fill,
                    fillOpacity: 0.3,
                    visible: true,
                });
                rangeDataItem.get('grid').setAll({ ...i.strokeProperties, stroke });
                rangeDataItem.get('axisFill').setAll({ ...i.fillProperties, fill });
                rangeDataItem.get('label').setAll({ ...i.labelProperties, centerX, centerY });
            });
        });
    }
    formatLocale() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let caTranslate;
        let esTranslate;
        let enTranslate;
        if ((_b = (_a = this.chartOptions) === null || _a === void 0 ? void 0 : _a.customTranslate) === null || _b === void 0 ? void 0 : _b.active) {
            caTranslate = ((_c = this.chartOptions) === null || _c === void 0 ? void 0 : _c.customTranslate.ca)
                ? (_d = this.chartOptions) === null || _d === void 0 ? void 0 : _d.customTranslate.ca
                : am5locales_ca_ES;
            esTranslate = ((_e = this.chartOptions) === null || _e === void 0 ? void 0 : _e.customTranslate.es)
                ? (_f = this.chartOptions) === null || _f === void 0 ? void 0 : _f.customTranslate.es
                : am5locales_ca_ES;
            enTranslate = ((_g = this.chartOptions) === null || _g === void 0 ? void 0 : _g.customTranslate.en)
                ? (_h = this.chartOptions) === null || _h === void 0 ? void 0 : _h.customTranslate.en
                : am5locales_ca_ES;
        }
        else {
            caTranslate = am5locales_ca_ES;
            esTranslate = am5locales_es_ES;
            enTranslate = am5locales_en;
        }
        switch (getLocale()) {
            case 'ca':
                caTranslate.dateHourFull = 'dd/MM/yyyy HH:mm';
                this.root.locale = caTranslate;
                break;
            case 'es':
                esTranslate.dateHourFull = 'dd/MM/yyyy HH:mm';
                this.root.locale = esTranslate;
                break;
            case 'en':
                enTranslate.dateHourFull = 'MM/dd/yyyy HH:mm';
                this.root.locale = enTranslate;
                break;
            default:
                esTranslate.dateHourFull = 'dd/MM/yyyy HH:mm';
                this.root.locale = esTranslate;
        }
        // Default DateFormater
        this.root.dateFormatter.set('dateFormat', 'dd/MM/yyyy');
    }
    /**
     * We store the configuration serie in the amcharts
     */
    setSerie(serie) {
        this.seriesModel.push(serie);
    }
    /**
    * Configure the legend of the chart in case the model is setted.
    */
    initLegend() {
        var _a;
        let disableLegend = false;
        // Check if legend exists before proceeding
        if (this.rootLegend) {
            const legend = this.rootLegend.container.children.push(am5.Legend.new(this.rootLegend, {
                width: am5.p100,
                height: am5.p100,
                centerX: am5.p50,
                layout: this.rootLegend.gridLayout,
                x: am5.p50,
                useDefaultMarker: true,
                verticalScrollbar: am5.Scrollbar.new(this.rootLegend, {
                    orientation: 'vertical',
                    wheelable: true,
                    visible: true,
                }),
            }));
            if ((_a = this.chartOptions) === null || _a === void 0 ? void 0 : _a.disableLegend) {
                disableLegend = true;
            }
            if (!disableLegend) {
                legend.itemContainers.template.events.on('pointerover', (e) => {
                    const itemContainer = e.target;
                    const seriesContainer = itemContainer.dataItem.dataContext;
                    this.pointerOverEvent(this.chart.series, seriesContainer);
                });
            }
            legend.itemContainers.template.events.on('pointerout', () => {
                this.pointerOutEvent(this.chart.series);
            });
            let legendSeries = this.chart.series.values;
            // If model is a ChartRange then we hide the lower series of range
            this.seriesModel.forEach((model) => {
                if (model instanceof ChartRange) {
                    legendSeries = legendSeries.filter((item) => item.uid !== model.hiddenSerie.uid);
                }
            });
            legend.data.setAll(legendSeries);
        }
    }
    /**
     * Handler for the pointerOver event, which is called when the user
     * hovers the mouse over a chart series.
     * @param {any} series - The chart series being hovered over.
     * @param {any} seriesContainer - The container for the chart series.
     */
    pointerOverEvent(series, seriesContainer) {
        var _a, _b;
        const highlightedSeries = [seriesContainer];
        // If relatedSerie is set then we are highlighting a ChartRange
        if ((_a = seriesContainer.get('userData')) === null || _a === void 0 ? void 0 : _a.relatedSerie) {
            highlightedSeries.push((_b = seriesContainer.get('userData')) === null || _b === void 0 ? void 0 : _b.relatedSerie);
        }
        series.each((chartSeries) => {
            const { className } = chartSeries.constructor;
            let seriesTypeInstace = chartSeries.strokes;
            // Default settings
            let settings = { strokeWidth: 5 };
            if (className === 'ColumnSeries') {
                seriesTypeInstace = chartSeries.columns;
                settings = {
                    ...settings,
                    cornerRadiusTL: 0,
                    cornerRadiusTR: 0,
                };
            }
            if (highlightedSeries.find((serie) => serie.uid === chartSeries.uid) === undefined) {
                settings = {
                    strokeOpacity: 0.15,
                    fillOpacity: 0.15,
                    stroke: am5.color(0x000000),
                    templateField: '',
                };
                chartSeries.bullets.clear();
            }
            this.setTemplateSettings(seriesTypeInstace, settings);
        });
    }
    /**
     * Handler for the pointerOut event, which is called when the user
     * moves the mouse away from a chart series.
     * @param {any} series - The chart series being hovered over.
     */
    pointerOutEvent(series) {
        series.each((chartSeries) => {
            var _a;
            const { className } = chartSeries.constructor;
            const strokeWidth = className === 'SmoothedXLineSeries' ? 5 : 2;
            let seriesTypeInstace = chartSeries.strokes;
            const settings = {
                strokeOpacity: 1,
                fillOpacity: 1,
                strokeWidth,
                stroke: chartSeries.get('stroke'),
                templateField: 'strokeSettings',
            };
            if (className === 'ColumnSeries') {
                seriesTypeInstace = chartSeries.columns;
                // eslint-disable-next-line no-underscore-dangle
                const isStacked = !!((_a = chartSeries._settings) === null || _a === void 0 ? void 0 : _a.stacked);
                if (!isStacked) {
                    settings.cornerRadiusTL = 5;
                    settings.cornerRadiusTR = 5;
                }
            }
            this.setTemplateSettings(seriesTypeInstace, settings);
        });
        this.seriesModel.forEach((item) => item.showBullets());
    }
    /**
    * Sets the template settings for a given series instance.
    * @param seriesTypeInstace - The instance of the series object.
    * @param setting - The settings object to be applied to the series instance.
    */
    setTemplateSettings(seriesTypeInstace, setting) {
        seriesTypeInstace.template.setAll(setting);
    }
    /**
    * Sets the x-axis and y-axis configuration for a chart component based on the input model.
    * @param model - The chart component model containing the configuration for the x- and y-axes.
    */
    setAxisFromModel(model) {
        model.models.forEach((dataModel) => {
            const xAxisIds = Array.from(new Set(dataModel.xAxes.filter((serie) => serie.id)
                .map((serie) => serie.id)));
            const yAxisIds = Array.from(new Set(dataModel.yAxes.filter((serie) => serie.id)
                .map((serie) => serie.id)));
            this.root.numberFormatter.set('numberFormat', dataModel.decimalNumber ? `#.${'0'.repeat(dataModel.decimalNumber)}` : '#.00');
            const xAxis = xAxisIds.map((xAxeId) => dataModel.xAxes.find((xAxe) => xAxe.id === xAxeId));
            const yAxis = yAxisIds.map((yAxeId) => dataModel.yAxes.find((yAxe) => yAxe.id === yAxeId));
            this.xAxis = this.createAxisByType(xAxis, 'xAxis');
            this.yAxis = this.createAxisByType(yAxis, 'yAxis');
        });
    }
    /**
    * Creates an axis element based on the axis type specified in axisType.
    * @param axisInstance An array of IChartAxisConfiguration objects that will be
    * used to create the axis.
    * @param axisType A string value representing the type of axis to be created.
    * @returns An axisElement object created based on the axisType parameter.
    */
    createAxisByType(axisInstance, axisType) {
        let axisElement;
        axisInstance.forEach((axis) => {
            if (!axis) {
                return;
            }
            switch (axis.type.toLocaleLowerCase()) {
                case 'date':
                    axisElement = this.createAxisDateFromConfig(axis, axisType);
                    break;
                case 'value':
                    axisElement = this.createAxisValueFromConfig(axis, axisType);
                    break;
                case 'category':
                    if (!axisElement) {
                        axisElement = this.createAxisCategoryFromConfig(axis, axisType);
                    }
                    else {
                        axisElement.complementaryAxis = this.createAxisCategoryFromConfig(axis, axisType);
                    }
                    break;
                default:
                    break;
            }
            if (axisType === 'yAxis') {
                this.yAxisUnits[axis.id] = axis.unitSymbol;
                this.yAxisAll.push(axisElement);
            }
            else {
                this.xAxisAll.push(axisElement);
            }
        });
        return axisElement;
    }
    /**
     * It creates an x-axis with a date axis renderer, and then hides the grid and labels.
     * @returns The xAxis object.
     */
    createAxisDateFromConfig(config, axisType) {
        var _a;
        const opposite = config.align === 'Right' || config.align === 'Up';
        const { renderer, chartAxis } = this.setGenericConfig(axisType, config, opposite);
        const axisResult = chartAxis.values.filter((item) => item.name === config.id.toString());
        if (axisResult && axisResult.length > 0) {
            return chartAxis;
        }
        const axis = chartAxis.push(am5xy.DateAxis.new(this.root, {
            categoryField: 'category',
            renderer,
            baseInterval: {
                timeUnit: ((_a = this.chartOptions) === null || _a === void 0 ? void 0 : _a.unitType) || 'minute',
                count: 1,
            },
        }));
        if (config.isAutoScale) {
            axis.set('gridIntervals', [
                { timeUnit: 'second', count: 1 },
                { timeUnit: 'minute', count: 1 },
                { timeUnit: 'minute', count: 5 },
                { timeUnit: 'hour', count: 1 },
                { timeUnit: 'day', count: 1 },
                { timeUnit: 'day', count: 7 },
                { timeUnit: 'day', count: 15 },
                { timeUnit: 'week', count: 1 },
                { timeUnit: 'month', count: 1 },
                { timeUnit: 'month', count: 3 },
                { timeUnit: 'month', count: 4 },
                { timeUnit: 'month', count: 6 },
                { timeUnit: 'year', count: 1 },
            ]);
        }
        axis.name = config.id.toString();
        if (config.enableTooltip) {
            axis.set('tooltip', am5.Tooltip.new(this.root, {
                themeTags: ['axis'],
            }));
        }
        renderer.labels.template.set('visible', config.visible);
        return axis;
    }
    /**
     * It creates an x-axis with a category axis render, and then hides the grid.
     * @returns The xAxis object.
     */
    createAxisValueFromConfig(config, axisType) {
        const opposite = config.align === 'Right' || config.align === 'Up';
        const { renderer, chartAxis } = this.setGenericConfig(axisType, config, opposite);
        const axisResult = chartAxis.values.filter((item) => item.name === config.id.toString());
        if (axisResult && axisResult.length > 0) {
            return chartAxis;
        }
        const axis = chartAxis.push(am5xy.ValueAxis.new(this.root, {
            numberFormat: config.externalUnit ? `#${config.labelFormat}` : `#${config.labelFormat} ${config.unitSymbol}`,
            valueYField: 'value',
            tooltipNumberFormat: `${config.labelFormat}  ${config.unitSymbol}`,
            renderer,
            calculateTotals: true,
            visible: config.visible,
        }));
        if (config.externalUnit) {
            axis.children.unshift(am5.Label.new(this.root, {
                rotation: -90,
                text: config.unitSymbol,
                y: am5.p50,
                x: opposite ? am5.p100 : null,
                centerX: am5.p50,
            }));
        }
        if (!config.isAutoScale) {
            axis.set('min', config.minimum);
            axis.set('max', config.maximum);
        }
        axis.name = config.id.toString();
        if (config.enableTooltip) {
            axis.set('tooltip', am5.Tooltip.new(this.root, {
                themeTags: ['axis'],
            }));
        }
        return axis;
    }
    /**
     * It creates an x-axis with a category axis render, and then hides the grid.
     * @returns The xAxis object.
     */
    createAxisCategoryFromConfig(config, axisType) {
        const opposite = config.align === 'Right' || config.align === 'Up';
        const { renderer, chartAxis } = this.setGenericConfig(axisType, config, opposite);
        const axisResult = chartAxis.values.filter((item) => item.name === config.id.toString());
        if (axisResult && axisResult.length > 0) {
            return chartAxis;
        }
        const axis = chartAxis.push(am5xy.CategoryAxis.new(this.root, {
            categoryField: config.categoryField ? config.categoryField : 'category',
            renderer,
            visible: config.visible,
        }));
        axis.name = config.id.toString();
        if (config.enableTooltip) {
            axis.set('tooltip', am5.Tooltip.new(this.root, {
                themeTags: ['axis'],
            }));
        }
        return axis;
    }
    /**
   * This function sets the generic configuration for a chart axis in an amCharts 5 (am5) XY chart.
   * @param axisType - A string that specifies which axis (x or y) to configure.
   * @param opposite - A boolean that specifies whether the axis should be positioned opposite.
   * @param cellLocation - A number used to calculate the left|right padding on the axis.
   * @returns An object containing two properties: renderer and chartAxis.
   */
    setGenericConfig(axisType, config, opposite) {
        let renderer;
        let chartAxis;
        let cellStartLocation = 0;
        let cellEndLocation = 1;
        if (config.paddingCell) {
            cellStartLocation += config.paddingCell;
            cellEndLocation -= config.paddingCell;
        }
        if (axisType === 'yAxis') {
            renderer = am5xy.AxisRendererY.new(this.root, {
                opposite,
                cellStartLocation,
                cellEndLocation,
            });
            chartAxis = this.chart.yAxes;
        }
        else {
            renderer = am5xy.AxisRendererX.new(this.root, {
                opposite,
                cellStartLocation,
                cellEndLocation,
            });
            chartAxis = this.chart.xAxes;
        }
        return { renderer, chartAxis };
    }
    /**
     * If the chart type is a pie chart, return an object with null values for the x and y axis.
     * Otherwise, create the x and y axis and return an object with those values.
     * @returns An object with two properties, xAxis and yAxis.
     */
    createAxis() {
        if (this.typeChart === 'pieChart')
            return { xAxis: null, yAxis: null };
        const xAxis = this.createXAxis();
        const yAxis = this.createYAxis();
        return { xAxis, yAxis };
    }
    /**
     * This method destroy AmChartBase elements
     */
    destroy() {
        if (this.root) {
            this.root.dispose();
        }
        if (this.rootLegend) {
            this.rootLegend.dispose();
        }
        if (this.chart) {
            this.chart.dispose();
        }
        this.root = null;
        this.rootLegend = null;
        this.chart = null;
        this.xAxis = null;
        this.xAxisAll = [];
        this.yAxis = null;
        this.yAxisAll = [];
        this.typeChart = null;
    }
    /**
     *
     * @param {string | Number | Date} typeXAxisChart - string | Number | Date
     * @returns If xAxis needed to set String (Category) or Date
     */
    checkXAxisType(typeXAxisChart) {
        let xAxisType = 'string';
        if (Object.prototype.toString.call(typeXAxisChart) === '[object Date]') {
            xAxisType = 'date';
        }
        return xAxisType;
    }
    /**
     * Sets the license key for the amCharts library
     */
    setLicenseKey() {
        am5.addLicense(__classPrivateFieldGet(this, _AmChartsBase_keyLicense, "f"));
    }
    /**
     * It creates a root element and sets the themes
     * @param {string | HTMLElement} rootElement - string | HTMLElement
     * @returns The root element is being returned.
     */
    createRootElement(rootElement) {
        // Create root element
        const root = am5.Root.new(rootElement, {
            tooltipContainerBounds: {
                top: 200,
                right: 100,
                bottom: 200,
                left: 100,
            },
        });
        // Set themes
        root.setThemes([
            am5themesAnimated.new(root),
        ]);
        return root;
    }
    createLegendRootElement(rootElement) {
        // Create root element
        let root = null;
        if (rootElement) {
            root = am5.Root.new(rootElement);
            // Set themes
            root.setThemes([
                am5themesAnimated.new(root),
                am5xy.DefaultTheme.new(root),
            ]);
        }
        return root;
    }
    /**
     * Create a new XYChart object, and add it to the root container.
     * @returns The chart object.
     */
    createXYChart() {
        // Create chart
        const chart = this.root.container.children.push(am5xy.XYChart.new(this.root, {
            layout: this.root.verticalLayout,
            height: am5.p100,
            width: am5.p100,
            maxTooltipDistance: 0,
        }));
        return chart;
    }
    /**
     * Create a PieChart object and add it to the root container.
     * @returns The chart object.
     */
    createPieChart() {
        // Create PieChart
        const chart = this.root.container.children.push(am5percent.PieChart.new(this.root, {
            layout: this.root.verticalLayout,
        }));
        return chart;
    }
    /**
     * If the type is line, bar, or area, create an XY chart, otherwise create a pie chart.
     * @param {TypeCharts} type - TypeCharts = 'line' | 'bar' | 'area' | 'pieChart' | 'range';
     * @returns The chart object.
     */
    createChartByType(type) {
        let chart = null;
        if (type === 'line' || type === 'bar' || type === 'area' || type === 'stacked' || type === 'range') {
            chart = this.createXYChart();
        }
        else if (type === 'pieChart') {
            chart = this.createPieChart();
        }
        return chart;
    }
    /**
     * If the xAxisType is date, then create an xAxis of type date, otherwise create an xAxis of type
     * category.
     * @returns The return value is the result of correct function.
     */
    createXAxis() {
        if (this.xAxisType === 'date') {
            return this.createXaxisDate();
        }
        return this.createXaxisCategory();
    }
    /**
     * It creates an x-axis with a category axis render, and then hides the grid.
     * @returns The xAxis object.
     */
    createXaxisCategory() {
        const xRenderer = am5xy.AxisRendererX.new(this.root, { minGridDistance: 30 });
        const xAxis = this.chart.xAxes.push(am5xy.CategoryAxis.new(this.root, {
            maxDeviation: 0.5,
            categoryField: 'category',
            renderer: xRenderer,
            visible: false,
        }));
        xRenderer.grid.template.set('forceHidden', true);
        return xAxis;
    }
    /**
     * It creates an x-axis with a date axis renderer, and then hides the grid and labels.
     * @returns The xAxis object.
     */
    createXaxisDate() {
        var _a;
        const xRenderer = am5xy.AxisRendererX.new(this.root, { minGridDistance: 30 });
        const xAxis = this.chart.xAxes.push(am5xy.DateAxis.new(this.root, {
            maxDeviation: 0.5,
            baseInterval: {
                timeUnit: ((_a = this.chartOptions) === null || _a === void 0 ? void 0 : _a.unitType) || 'day',
                count: 1,
            },
            renderer: xRenderer,
        }));
        xRenderer.grid.template.set('forceHidden', true);
        xRenderer.labels.template.set('visible', false);
        return xAxis;
    }
    /**
     * It creates a Y axis and then hides the grid.
     * @returns The yAxis object.
     */
    createYAxis() {
        var _a, _b, _c, _d, _e;
        const yRenderer = am5xy.AxisRendererY.new(this.root, {});
        const valueAxis = {
            maxDeviation: 0.3,
            renderer: yRenderer,
            visible: false,
        };
        const isTotalPercent = (_a = this.chartOptions) === null || _a === void 0 ? void 0 : _a.isTotalPercent;
        const strictMinMax = (_c = (_b = this.chartOptions) === null || _b === void 0 ? void 0 : _b.yAxis) === null || _c === void 0 ? void 0 : _c.strictMinMax;
        const min = (_e = (_d = this.chartOptions) === null || _d === void 0 ? void 0 : _d.yAxis) === null || _e === void 0 ? void 0 : _e.min;
        if (this.typeChart === 'stacked' && isTotalPercent) {
            valueAxis.min = 0;
            valueAxis.max = 100;
            valueAxis.calculateTotals = true;
        }
        if (strictMinMax || strictMinMax === undefined) {
            valueAxis.strictMinMax = true;
            valueAxis.extraMin = 0.1;
            valueAxis.extraMax = 0.1;
        }
        if (min === null || min === void 0 ? void 0 : min.toString()) {
            if (min >= 0) {
                valueAxis.min = min;
            }
        }
        const yAxis = this.chart.yAxes.push(am5xy.ValueAxis.new(this.root, valueAxis));
        // Remove grid
        yRenderer.grid.template.set('forceHidden', true);
        return yAxis;
    }
    /**
     * The function generates a bullet object for the chart series
     * @param {IChartSeriesBulletOptions} bullets - IChartSeriesBulletOptions
     * @returns The method returns an object of type am5.Bullet.
     */
    generateBullet(bullets) {
        /* Destructuring the bullets object. */
        const { fillColor, strokeColor, radius, strokeWidth, } = bullets;
        /* Destructuring the object returned by the getDefaultBulletsColor() method. */
        const { fillDefault, strokeDefault, radiusDefault, strokeWidthDefault, } = this.getDefaultBulletsColor();
        const circleTemplate = am5.Template.new({
            radius: radius !== null && radius !== void 0 ? radius : radiusDefault,
            templateField: 'bulletSettings',
            fill: fillColor ? am5.color(fillColor) : am5.color(fillDefault),
            strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : strokeWidthDefault,
            stroke: strokeColor ? am5.color(strokeColor) : am5.color(strokeDefault),
        });
        const circle = am5.Circle.new(this.root, {}, circleTemplate);
        return am5.Bullet.new(this.root, {
            sprite: circle,
            locationX: 0.5,
        });
    }
    /**
     * If the xAxisType is date, then the labelText will be formatted as a date. Otherwise, it will be
     * formatted as a string.
     * @returns The labelText is being returned.
     */
    getLabelText(tooltipFormat, axisId) {
        var _a;
        let labelText = '';
        const unit = (_a = this.yAxisUnits[axisId]) !== null && _a !== void 0 ? _a : '';
        if (tooltipFormat) {
            labelText = `${tooltipFormat} ${unit}`;
        }
        else {
            labelText = `{name}:\n{valueX}: [bold]{valueY} ${unit}`;
            if (this.xAxisType === 'date') {
                // eslint-disable-next-line no-underscore-dangle
                labelText = `{name}:\n{valueX.formatDate("${this.root.locale.dateHourFull}")}: [bold]{valueY} ${unit}`;
            }
        }
        return labelText.trim();
    }
    /**
     * It creates a tooltip object and returns it.
     * @returns The tooltip object.
     */
    generateTooltip(tooltipFormat, axisId) {
        const labelText = this.getLabelText(tooltipFormat, axisId);
        const tooltip = am5.Tooltip.new(this.root, {
            labelText,
        });
        return tooltip;
    }
    /**
    * It returns an object with default bullets properties.
    * @returns An object
    */
    getDefaultBulletsColor() {
        return {
            fillDefault: '#c5c2c2',
            strokeDefault: '#d1f2f5',
            radiusDefault: 4,
            strokeWidthDefault: 2,
        };
    }
    /**
     * It takes an array of objects with a category property and returns an array of objects with a
     * category property.
     * If the category is Date prepare the data to timestamp otherwise return serie
     * @param series - Array<IChartSeriesData>;
     * @returns The return value is an array of objects.
     */
    prepareSeriesData(series) {
        if (this.xAxisType === 'date') {
            return series.map((i) => {
                const convertDate = i.category instanceof Date ? i.category : new Date(i.category);
                const categoryDate = convertDate;
                return { ...i, category: categoryDate.getTime() };
            });
        }
        return series;
    }
    /**
     * Check if xAxisType is the same type of XAxis CategorySerie
     * @param {string | number | Date} categorySerie - string | number | Date
     * @returns The return value is a boolean.
     */
    validate(categorySerie) {
        return this.xAxisType === this.checkXAxisType(categorySerie);
    }
    /**
     * If the typeChart is pieChart, then return true if the typeChart is pieChart, otherwise if the
     * typeChart is line, bar, or area, then return true if the typeChart is line, bar, or area.
     * @param {TypeCharts} typeChart - TypeCharts
     * @returns A boolean value.
     */
    validateTypeChart(typeChart) {
        let isValid = false;
        if (typeChart === 'pieChart') {
            isValid = this.typeChart === typeChart;
        }
        else if (typeChart === 'line' || typeChart === 'bar' || typeChart === 'area' || typeChart === 'range') {
            isValid = this.typeChart === 'line' || this.typeChart === 'bar' || this.typeChart === 'area' || this.typeChart === 'range';
        }
        else if (typeChart === 'stacked') {
            isValid = this.typeChart === 'stacked';
        }
        return isValid;
    }
    /**
     * Clear the existing paddings and set min of 5
     */
    clearPadding(typeOfSerie) {
        if (!this.chart)
            return;
        if (typeOfSerie !== 'bar') {
            this.chart.setAll({
                paddingRight: -8,
                paddingLeft: -8,
                paddingTop: 5,
                paddingBottom: 5,
            });
        }
        else {
            this.chart.setAll({
                paddingRight: 3,
                paddingLeft: 3,
                paddingTop: 5,
                paddingBottom: 5,
            });
        }
    }
}
_AmChartsBase_keyLicense = new WeakMap();
//# sourceMappingURL=amchartsBase.js.map